exports = module.exports = require("../../../../../../node_modules/_css-loader@0.26.4@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".i-editor .dashboard .dashboard-font{line-height:36px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.26.4@css-loader?minimize!./~/_vue-loader@10.3.0@vue-loader/lib/style-rewriter.js?id=data-v-0230f4c8!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=styles&index=0!./src/components/editor/src/modules/font/dashboard.vue
// module id = 471
// module chunks = 0